export default "__VITE_ASSET__19665e7b__"